<div class="designer-container">
  <!-- Loading Overlay -->
  <div class="overlay1" *ngIf="isLoading">
    <span class="loader"></span>
  </div>

  <div class="designer-layout">
    <!-- Left Panel: Customization Controls -->
    <div class="controls-panel">
      <div class="panel-header">
        <button type="button" class="back-btn" (click)="close()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <path d="M15 6l-6 6 6 6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Back to invite
        </button>
        <h2>Design your invitation</h2>
      </div>

      <div class="controls-content">
        <!-- Page Size Selection -->
        <div class="control-section">
          <h3>Page Size</h3>
          <select [(ngModel)]="selectedPageSize" class="control-input">
            <option *ngFor="let size of pageSizes" [value]="size.id">{{ size.name }}</option>
          </select>
        </div>

        <!-- Template Selection -->
        <div class="control-section">
          <h3>Select Template</h3>
          <div class="template-grid">
            <div *ngFor="let template of templates" 
                 class="template-item" 
                 [class.active]="selectedTemplate === template.id"
                 (click)="selectTemplate(template.id)">
              <div class="template-preview" [ngClass]="template.style">
                <span>{{ template.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Font Selection -->
        <div class="control-section">
          <h3>Font Family</h3>
          <select [(ngModel)]="selectedFont" class="control-input">
            <option *ngFor="let font of fonts" [value]="font">{{ font }}</option>
          </select>
        </div>

        <!-- Font Sizes -->
        <div class="control-section">
          <h3>Title Font Size</h3>
          <div class="slider-group">
            <input type="range" 
                   [(ngModel)]="titleFontSize" 
                   min="20" 
                   max="60" 
                   class="slider">
            <span class="slider-value">{{ titleFontSize }}px</span>
          </div>
        </div>

        <div class="control-section">
          <h3>Body Font Size</h3>
          <div class="slider-group">
            <input type="range" 
                   [(ngModel)]="bodyFontSize" 
                   min="12" 
                   max="32" 
                   class="slider">
            <span class="slider-value">{{ bodyFontSize }}px</span>
          </div>
        </div>

        <!-- Colors -->
        <div class="control-section">
          <h3>Colors</h3>
          <div class="color-group">
            <div class="color-item">
              <label>Title Color</label>
              <input type="color" [(ngModel)]="titleColor" class="color-picker">
            </div>
            <div class="color-item">
              <label>Body Color</label>
              <input type="color" [(ngModel)]="bodyColor" class="color-picker">
            </div>
            <div class="color-item">
              <label>Background</label>
              <input type="color" [(ngModel)]="backgroundColor" class="color-picker">
            </div>
            <div class="color-item">
              <label>Accent Color</label>
              <input type="color" [(ngModel)]="accentColor" class="color-picker">
            </div>
          </div>
        </div>

        <!-- Custom Message -->
        <div class="control-section">
          <h3>Custom Message</h3>
          <textarea [(ngModel)]="customMessage" 
                    class="control-textarea" 
                    rows="3"
                    maxlength="100"
                    placeholder="Enter your custom invitation message (max 100 characters)..."></textarea>
          <small style="color: #999; font-size: 11px;">{{ customMessage.length }}/100 characters</small>
        </div>

        <!-- Image Upload -->
        <div class="control-section">
          <h3>Add Image (Optional)</h3>
          <div class="image-upload-container">
            <input type="file" 
                   id="imageUpload" 
                   (change)="onImageUpload($event)" 
                   accept="image/*"
                   style="display: none;">
            <label for="imageUpload" class="btn-upload">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="3" y="5" width="18" height="14" rx="2.5" />
                <circle cx="9" cy="10.5" r="1.7" />
                <path d="M21 16l-5.5-5.5a1.5 1.5 0 0 0-2.12 0L4 20" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Choose image
            </label>
            <button type="button" *ngIf="uploadedImage" class="btn-remove-image" (click)="removeImage()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" />
              </svg>
              Remove
            </button>
          </div>
          <div *ngIf="uploadedImage" class="image-preview">
            <img [src]="uploadedImage" alt="Uploaded Image">
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="control-section">
          <button type="button" class="btn-reset" (click)="resetToDefaults()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 12a9 9 0 1 1 2.64 6.36M3 12V6m0 6h6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Reset to defaults
          </button>
        </div>
      </div>
    </div>

    <!-- Right Panel: Card Preview -->
    <div class="preview-panel">
      <div class="preview-header">
        <h3>Preview</h3>
        <div class="action-buttons">
          <button type="button" class="btn-download" (click)="downloadCard()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 19h14" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download
          </button>
          <button type="button" class="btn-share" (click)="shareCard()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="18" cy="5" r="2.6" /><circle cx="6" cy="12" r="2.6" /><circle cx="18" cy="19" r="2.6" />
              <path d="M8.3 10.7l7.4-4.2M8.3 13.3l7.4 4.2" stroke-linecap="round" />
            </svg>
            Share
          </button>
        </div>
      </div>

      <div class="preview-content">
        <!-- Invitation Card Preview -->
        <div id="invitation-card" 
             class="invitation-card" 
             [ngClass]="[selectedTemplate, 'size-' + selectedPageSize]"
             [ngStyle]="getCardStyles()">
          
          <!-- Template 1: Classic -->
          <div *ngIf="selectedTemplate === 'template1'" class="card-template classic-template">
            <div class="card-border" [style.border-color]="accentColor">
              <!-- Uploaded Image -->
              <div *ngIf="uploadedImage" class="card-image">
                <img [src]="uploadedImage" alt="Event Image">
              </div>
              
              <div class="card-header">
                <div class="decorative-line" [style.background-color]="accentColor"></div>
                <h1 [ngStyle]="getTitleStyles()">{{ eventName }}</h1>
                <div class="decorative-line" [style.background-color]="accentColor"></div>
              </div>
              
              <div class="card-body">
                <p class="message" [ngStyle]="getBodyStyles()">{{ customMessage }}</p>
                
                <div class="event-details" [ngStyle]="getBodyStyles()">
                  <div class="detail-item" *ngIf="eventDate">
                    <i class="fa fa-calendar" [ngStyle]="getAccentStyles()"></i>
                    <span>{{ eventDate }}</span>
                  </div>
                  <div class="detail-item" *ngIf="eventTime">
                    <i class="fa fa-clock-o" [ngStyle]="getAccentStyles()"></i>
                    <span>{{ eventTime }}</span>
                  </div>
                  <div class="detail-item" *ngIf="eventLocation">
                    <i class="fa fa-map-marker" [ngStyle]="getAccentStyles()"></i>
                    <span>{{ eventLocation }}</span>
                  </div>
                </div>
                
                <div class="qr-section">
                  <p class="scan-text" [ngStyle]="getBodyStyles()">Scan to RSVP</p>
                  <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" class="qr-code">
                </div>
              </div>
            </div>
          </div>

          <!-- Template 4: Fun -->
          <div *ngIf="selectedTemplate === 'template4'" class="card-template fun-template">
            <div class="fun-shapes">
              <div class="shape circle" [style.background-color]="accentColor"></div>
              <div class="shape square" [style.border-color]="accentColor"></div>
              <div class="shape triangle" [style.border-bottom-color]="accentColor"></div>
            </div>
            
            <div class="fun-content">
              <!-- Uploaded Image -->
              <div *ngIf="uploadedImage" class="card-image fun-image">
                <img [src]="uploadedImage" alt="Event Image">
              </div>
              
              <h1 [ngStyle]="getTitleStyles()" class="fun-title">{{ eventName }}</h1>
              
              <p class="fun-message" [ngStyle]="getBodyStyles()">{{ customMessage }}</p>
              
              <div class="fun-details">
                <div class="fun-badge" *ngIf="eventDate" [style.background-color]="accentColor">
                  <i class="fa fa-calendar"></i>
                  <span>{{ eventDate }}</span>
                </div>
                <div class="fun-badge" *ngIf="eventTime" [style.background-color]="accentColor">
                  <i class="fa fa-clock-o"></i>
                  <span>{{ eventTime }}</span>
                </div>
                <div class="fun-badge" *ngIf="eventLocation" [style.background-color]="accentColor">
                  <i class="fa fa-map-marker"></i>
                  <span>{{ eventLocation }}</span>
                </div>
              </div>
              
              <div class="qr-fun">
                <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" class="qr-code">
                <p [ngStyle]="getBodyStyles()">Scan me! </p>
              </div>
            </div>
          </div>

          <!-- Custom Template -->
          <div *ngIf="selectedTemplate === 'custom'" class="card-template custom-template">
            <!-- Uploaded Image as Background or Top -->
            <div *ngIf="uploadedImage" class="custom-image-bg" [style.background-image]="'url(' + uploadedImage + ')'"></div>
            
            <div class="custom-content">
              <h1 [ngStyle]="getTitleStyles()">{{ eventName }}</h1>
              
              <p class="custom-message" [ngStyle]="getBodyStyles()">{{ customMessage }}</p>
              
              <div class="custom-details" [ngStyle]="getBodyStyles()">
                <div class="custom-detail-item" *ngIf="eventDate">
                  <i class="fa fa-calendar" [ngStyle]="getAccentStyles()"></i>
                  <span>{{ eventDate | date: 'fullDate' }}</span>
                </div>
                <div class="custom-detail-item" *ngIf="eventTime">
                  <i class="fa fa-clock-o" [ngStyle]="getAccentStyles()"></i>
                  <span>{{ eventDate | date: 'shortTime' }}</span>
                </div>
                <div class="custom-detail-item" *ngIf="eventLocation">
                  <i class="fa fa-map-marker" [ngStyle]="getAccentStyles()"></i>
                  <span>{{ eventLocation }}</span>
                </div>
              </div>
              
              <div class="custom-qr">
                <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
